<template>
  <div class="fill-height d-flex flex-column">
    <div>
      <v-container fluid class="px-8 py-0">
        <v-row class="mt-4 mb-2">
          <v-col>
            <h2
              v-if="title"
              class="text-h3 navy--text text--darken-1 font-weight-bold"
              v-text="title"
            />
          </v-col>
          <v-col class="d-flex align-center justify-end">
            <v-btn
              v-if="showSaveDraft"
              text
              small
              class="navy--text text--darken-1"
              @click="onSaveDraftClick"
              :disabled="!model._changed"
            >
              <img
                class="mr-2"
                :src="require('@/assets/ico-save-blue.svg')"
                alt=""
              />
              Uložit jako rozepsanou
            </v-btn>
          </v-col>
        </v-row>

        <slot />
      </v-container>
    </div>
    <div class="mt-auto pt-6">
      <v-container fluid class="px-8">
        <slot name="footer">
          <ButtonBarWizard
            :prev="prev"
            :next="next"
            :next-disabled="nextDisabled"
            @next="onNext"
          >
            <template #left-append>
              <slot name="navigation-left-append" />
            </template>
            <template #right-prepend>
              <slot name="navigation-right-prepend" />
            </template>
          </ButtonBarWizard>
        </slot>
      </v-container>
    </div>
  </div>
</template>

<script>
import { call, get } from "vuex-pathify"

import ButtonBarWizard from "@/components/ui/buttonBars/ButtonBarWizard"
import Toastification from "../../../ui/Toastification"

export default {
  components: {
    ButtonBarWizard,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    showSaveDraft: {
      type: Boolean,
      default: true,
    },
    prev: {
      type: String,
      default: null,
    },
    next: {
      type: [String, Boolean],
      default: null,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...get("ads", ["model"]),
  },
  methods: {
    ...call("ads", ["saveAdDraft"]),
    onSaveDraftClick() {
      this.saveAdDraft().then(() => {
        this.$toast.success({
          component: Toastification,
          props: {
            title: "Rozepsaná reklama uložena",
            text: "Vaše reklama byla uložena mezi rozepsané.",
          },
        })
      })
    },
    onNext() {
      this.$emit("next")
    },
  },
}
</script>
